<script setup>
import NumberInput from '@/Components/Inputs/NumberInput.vue';
import NewPrice from "@/Components/Product/NewPrice.vue";
import Placeholder from '@/assets/images/product-placeholder.webp';
import {useCartStore} from '@/stores/cart.js';
import {XMarkIcon} from '@heroicons/vue/20/solid';

const shoppingCart = useCartStore();

</script>

<template>
    <div class="flex flex-col gap-5 text-left">
        <template
            v-for="(line) in shoppingCart.lines"
            :key="line.id"
        >
            <div
                class="flex rounded-3xl bg-white sm:rounded-xl"
            >
                <div class="relative m-2 flex aspect-square h-full max-h-45 justify-center">
                    <div class="w-full overflow-hidden rounded-3xl bg-red-50 sm:rounded-xl">
                        <img
                            :src="line.product.first_media?.src ?? line.product.parent?.first_media?.src ?? Placeholder"
                            alt="Cart item"
                            class="size-full object-cover"
                        >
                    </div>
                </div>

                <div class="flex w-full flex-col gap-4 p-2">
                    <div>
                        <p class="px-1 text-sm font-bold">
                            {{ line.product.title }}
                        </p>
                        <p
                            v-if="line.product.variant_label"
                            class="px-1 text-xs font-bold text-lightGray-600"
                        >
                            {{ line.product.variant_label }}
                        </p>

                        <div class="flex items-end justify-between">
                            <div>
                                <p class="px-1 text-sm font-bold">
                                    {{ $t(Object.keys(line.product.properties)[0]) }}
                                </p>
                                <p class="px-1 text-sm">
                                    <NewPrice
                                        :discount-price="line.price_including_vat"
                                        :price="line.regular_price_including_vat"
                                    />
                                </p>
                            </div>
                            <div class="flex items-center gap-2">
                                <span class="text-xl font-bold">
                                    <NewPrice
                                        :discount-price="line.total_including_vat"
                                        :hide-discount="true"
                                        :price="line.regular_total_including_vat"
                                    />
                                </span>
                                <button
                                    :class="line.product.is_deposit ? ' opacity-0' : 'cursor-pointer'"
                                    @click="shoppingCart.deleteProduct(line.product.id)"
                                >
                                    <x-mark-icon class="size-7" />
                                </button>
                            </div>
                        </div>
                    </div>

                    <NumberInput
                        v-model="line.quantity"
                        :disabled="line.product.is_deposit"
                        allow-zero
                        @update:model-value="shoppingCart.setQuantity(line, $event)"
                    />
                </div>
            </div>
        </template>
    </div>
</template>

